
import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import { FiEye, FiDownload, FiUpload } from "react-icons/fi";
import "./Docu.css";
import {  UpdateStudentDocument } from "../../../api/StudentServices";
import { closeModal, ToastMain ,SweetAlertShow} from "../../master/Master";
import { imgBaseUrl } from "../../../api/api";
import { json } from "react-router-dom";
import BaseForm from "../../Documents/Form";
import { studentDetails } from "../../../api/Student";

const Document = ({ data }) => {
  const hasAccess = usePrivateLink();
  const [Data, setData] = useState('');
  const student = data?.student || {};
  const [selectedCategory, setSelectedCategory] = useState('student')
  const [loading, setLoading] = useState(false)

  const getStudent = async () => {
    setLoading(true);
    try {
      const response = await studentDetails(`id=${student.id}`);
      if (response.data) {
        setData(response?.data);
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
    
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
   
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getStudent();
  }, [])
  const documents = data?.student?.documents || [];
  const handleDownload = async (url, filename) => {
    try {
      // ⚡ Fetch file as blob
      const response = await fetch(url, { mode: "no-cors" }); // no-cors lagaya
      const blob = await response.blob();

      // ⚡ Create temporary link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "document";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed!");
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("admissionForm").innerHTML;
    const WinPrint = window.open("", "", "width=900,height=650");
    WinPrint.document.write(`
      <html>
        <head>
          <title>Admission Form</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body { font-family: Arial, sans-serif; background: #fff; color: #000; }
            .a4-sheet { width: 210mm; min-height: 297mm; margin: auto; padding: 20mm; border: 2px solid #000; background: #fff; }
            .form-header { text-align: center; margin-bottom: 20px; }
            .form-header img { height: 80px; margin-bottom: 10px; }
            .form-title { font-size: 22px; font-weight: bold; text-decoration: underline; }
            .section-title { font-weight: bold; margin: 25px 0 15px 0; background: #f1f1f1; padding: 8px 10px; border-left: 4px solid #7306c6; }
            .signature-box { border-top: 1px solid #000; margin-top: 60px; padding-top: 10px; text-align: center; }
            .underline-field { display:inline-block; border-bottom:1px dotted #000; min-width:200px; padding:0 4px; }
            @media print { body { -webkit-print-color-adjust: exact; } .a4-sheet { border: none; margin: 0; padding: 10mm; } }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    WinPrint.document.close();
    WinPrint.print();
  };
return (
    <div>



      <div className="container my-4">
        {/* {JSON.stringify(documents)} */}
        <div
          className="card shadow-sm border-0 rounded-4 p-4 mb-5"
          style={{ maxWidth: "800px", margin: "0 auto" }}
        >
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title text-primary fw-bold m-0">
              Student Documents
            </h5>

            {hasAccess('/student/documents/add') && (
              <a
                href="javascript:;"
                className="btn btn-primary me-4 waves-effect waves-light"
                data-bs-target="#editUser"
                data-bs-toggle="modal"
              >
                Upload Documents
              </a>
            )}
          </div>


          <div className="row g-3 mt-3">
            {documents?.map((doc) => {
              if (
                !doc?.path ||
                ["id", "user_id", "status", "remark", "created_at", "updated_at"].includes(doc?.type)
              ) {
                return null;
              }

              return (
                <div className="col-md-6" key={doc.id}>
                  <div className="border rounded-4 p-3 h-100 shadow-sm">
                    <h6 className="fw-semibold mb-2">
                      {doc?.category?.title?.toUpperCase()}
                    </h6>

                    <div className="d-flex justify-content-between align-items-center">
                      <img
                        src={`${imgBaseUrl}${doc?.path}`}
                        alt={doc?.doc_type}
                        style={{
                          height: "60px",
                          width: "60px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #ddd"
                        }}
                      />

                      <div className="d-flex gap-2">
                        <a
                          href={`${imgBaseUrl}${doc?.path}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-primary"
                        >
                          <FiEye />
                        </a>

                        <button
                          onClick={() =>
                            handleDownload(
                              `${imgBaseUrl}${doc?.path}`,
                              `${doc?.doc_type}_${doc?.id}.jpeg`
                            )
                          }
                          className="btn btn-sm btn-outline-success"
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>



      <div className="modal fade" id="editUser" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-simple modal-edit-user">
          <div className="modal-content">
            <div className="modal-body p-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div className="text-center mb-6">
                {/* {JSON.stringify(student?.course_and_fees?.[0]?.batch_id || [])} */}
                <h4 className="mb-2">Upload Student Documents</h4>
                {/* <p className="mb-6">
                  Updating user details will receive a privacy audit.
                </p> */}
              </div>

              <BaseForm defaultCategory={selectedCategory} StudentId={student?.id} batch_id={student?.course_and_fees?.[0]?.batch_id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Document;
